import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";

import { ShapeState } from "./types";

const state = {} as ShapeState;

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
